export const Adminbox = {
    selectors: {
        openSelector: document.querySelector('.js-adminbox--open'),
        closeSelector: document.querySelector('.js-adminbox--close'),
        contentSelector: document.querySelector('.js-adminbox--content'),
		ajaxSelector: document.querySelector('.js-adminbox--ajax'),
		wholeSelector: document.querySelector('.js-adminbox'),
        supportNotesOpenSelector: document.querySelector('.js-supportnotesbox--open'),
        supportNotesIconSelector: document.querySelector('.js-supportnotesbox--icon'),
		supportNotesContentSelector: document.querySelector('.js-supportnotesbox--content'),
    },

    init: function() {
        let self = this;

        if (self.selectors.wholeSelector) {
        	self.selectors.openSelector.addEventListener('click', function (event) {
				self.toggleAdminbox();
				self.renderContent(this);
			});
            self.selectors.closeSelector.addEventListener('click', function (event) {
                self.toggleAdminbox();
            });
		}
    },
	toggleAdminbox: function () {
  		let self = this;
  		if (!self.selectors.contentSelector.classList.contains('is-active')) {
            self.selectors.contentSelector.classList.add('is-active');
            self.selectors.openSelector.classList.add('u-hidden');
  			return;
		}
        self.selectors.contentSelector.classList.remove('is-active');
        self.selectors.openSelector.classList.remove('u-hidden');

        if (self.selectors.supportNotesOpenSelector) {
            if (self.selectors.supportNotesOpenSelector.classList.contains('u-hidden')) {
                self.selectors.supportNotesContentSelector.classList.remove('is-active');
                self.selectors.supportNotesOpenSelector.classList.add('u-hidden');
                self.selectors.supportNotesIconSelector.classList.add('u-hidden');
            }
        }
	},
    renderContent: function (_selector) {
        let self = this;
        let url = _selector.dataset.url;
        self.ajaxRequest(url).then((result) => {self.updateAdminbox(result)}, self.errorHandler);
    },
    updateAdminbox: function (_response) {
        let self = this;
        self.selectors.ajaxSelector.innerHTML = _response.content;
    },
    ajaxRequest: function(_serviceURL) {
        let promiseObj = new Promise(function(resolve, reject) {
            let requestURL = _serviceURL;
            let request = new XMLHttpRequest();

            request.open('GET', requestURL);
            request.responseType = 'json';
            request.send();
            request.onreadystatechange = function() {
                if (request.readyState === 4){
                    if (request.status === 200){
                        resolve(request.response);
                    } else {
                        reject(request.status);
                        console.log("xhr failed");
                    }
                }
            }
        });
        return promiseObj;
    },

    errorHandler: function(_statusCode) {
        console.log("failed with status", _statusCode);
    },
};

Adminbox.init();